import {useAppSelector} from 'hooks';

import {safeToFixed} from '../utils/helper';

export const useExpressDimensionLimit = () => {
  const {basket} = useAppSelector((state) => state.basket);
  const threshold = basket?.expressDimensionLimit || Infinity;
  const totalDimension = basket?.totalOrderDimension || 0;
  const percentage = (totalDimension * 100) / threshold;

  return {
    isWithinThreshold: percentage <= 100,
    threshold: +safeToFixed(threshold),
    totalDimension: +safeToFixed(totalDimension),
    percentage
  };
};
